// GENERATED by scripts/gen-replay-script.mjs from src/capture/replayFrame.ts — do not edit by hand.
// After changing that file or anything it imports, run `npm run gen:replay` and commit the result.

/** Identifies REPLAY_SCRIPT: the player asks for the replay with it, so a new script is never served from an old cache. */
export const REPLAY_VERSION = "7aaca762760c";

/** The script the scrollable replay runs (see server/capture.ts). Embedded verbatim and allowed by its hash. */
export const REPLAY_SCRIPT = `"use strict";
(() => {
  // shared/anchors.ts
  var ANCHOR_ATTR = "data-ih-anchor";
  var TOKEN = /^([A-Za-z0-9_-]+)(?:@(-?\\d+(?:\\.\\d+)?),(-?\\d+(?:\\.\\d+)?))?$/;
  function parseAnchors(attr) {
    const out = [];
    for (const raw of (attr ?? "").split(/\\s+/)) {
      const m = TOKEN.exec(raw);
      if (m) out.push({ key: m[1], at: m[2] === void 0 ? null : [Number(m[2]), Number(m[3])] });
    }
    return out;
  }

  // src/capture/anchorDom.ts
  var styleOf = (d, el) => (d.defaultView ?? window).getComputedStyle(el);
  function covers(el, box) {
    const r = el.getBoundingClientRect();
    const area = (box.right - box.left) * (box.bottom - box.top);
    if (!r.width || !r.height || area <= 0) return false;
    const w = Math.min(r.right, box.right) - Math.max(r.left, box.left);
    const h = Math.min(r.bottom, box.bottom) - Math.max(r.top, box.top);
    return w > 0 && h > 0 && w * h / area >= 0.9;
  }
  function bestAnchorAt(d, x, y, box) {
    const els = d.elementsFromPoint(x, y);
    let pinned = null;
    for (const el of els) {
      if (el === d.documentElement || el === d.body) continue;
      const pos2 = styleOf(d, el).position;
      if (pos2 === "sticky" || pos2 === "fixed") {
        if (!pinned) pinned = el;
        continue;
      }
      return pinned && box && covers(pinned, box) ? pinned : el;
    }
    return pinned ?? d.elementFromPoint(x, y);
  }
  function anchorFor(d, box) {
    const el = bestAnchorAt(d, (box.left + box.right) / 2, (box.top + box.bottom) / 2, box);
    return el === d.documentElement ? d.body : el;
  }
  function anchorPx(d, el) {
    const r = el.getBoundingClientRect();
    if (!r.width && !r.height) return null;
    const isBody = el === d.body;
    return [r.left - (isBody ? d.body.scrollLeft : 0), r.top - (isBody ? d.body.scrollTop : 0)];
  }
  function pickScroller(d) {
    const de2 = d.scrollingElement ?? d.documentElement;
    const over = (el) => el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1;
    let best = null;
    let bestArea = 0;
    if (over(de2)) {
      best = de2;
      bestArea = de2.clientWidth * de2.clientHeight;
    }
    const els = d.body ? [d.body, ...Array.from(d.body.querySelectorAll("*"))] : [];
    for (const el of els) {
      if (el === de2 || /^(TEXTAREA|INPUT|SELECT)$/.test(el.tagName) || !over(el)) continue;
      const cs = styleOf(d, el);
      if (el !== d.body && !/auto|scroll|overlay/.test(cs.overflowY + " " + cs.overflowX)) continue;
      const area = el.clientWidth * el.clientHeight;
      if (area > bestArea) {
        best = el;
        bestArea = area;
      }
    }
    return best;
  }
  function windowScroll(d) {
    var _a, _b;
    const de2 = d.documentElement;
    return [de2.scrollLeft || ((_a = d.body) == null ? void 0 : _a.scrollLeft) || 0, de2.scrollTop || ((_b = d.body) == null ? void 0 : _b.scrollTop) || 0];
  }
  function scrollWindowTo(d, x, y) {
    const de2 = d.documentElement;
    if (d.defaultView) d.defaultView.scrollTo(x, y);
    else {
      de2.scrollLeft = x;
      de2.scrollTop = y;
    }
    if (y && de2.scrollTop !== y && d.body) {
      d.body.scrollLeft = x;
      d.body.scrollTop = y;
    }
  }
  function scrollPos(d, el) {
    if (!el) return [0, 0];
    const de2 = d.scrollingElement ?? d.documentElement;
    return el === de2 ? windowScroll(d) : [el.scrollLeft, el.scrollTop];
  }
  function scrollToTop(d, scroller2) {
    for (const el of [scroller2, d.documentElement, d.body]) {
      if (!el) continue;
      try {
        el.scrollTo({ top: 0, left: 0, behavior: "instant" });
      } catch {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      }
    }
  }
  function calloutElementAt(d, x, y) {
    const el = anchorFor(d, { left: x - 0.5, top: y - 0.5, right: x + 0.5, bottom: y + 0.5 });
    return el && el !== d.body && el !== d.documentElement ? el : null;
  }
  function calloutElement(d, scroller2, a) {
    const de2 = d.scrollingElement ?? d.documentElement;
    const els = [de2, d.documentElement, d.body, scroller2].filter((el, i, all) => !!el && all.indexOf(el) === i);
    const was = els.map((el) => [el.scrollLeft, el.scrollTop]);
    const go = (el, left, top) => {
      try {
        el.scrollTo({ left, top, behavior: "instant" });
      } catch {
        el.scrollLeft = left;
        el.scrollTop = top;
      }
    };
    try {
      if (!scroller2 || scroller2 === de2 || scroller2 === d.body) scrollWindowTo(d, a.sx, a.sy);
      else go(scroller2, a.sx, a.sy);
      return calloutElementAt(d, a.px, a.py);
    } finally {
      els.forEach((el, i) => go(el, was[i][0], was[i][1]));
    }
  }
  function calloutTip(d, el, a) {
    const p = el.isConnected ? anchorPx(d, el) : null;
    return p && [p[0] + a.ox, p[1] + a.oy];
  }

  // src/capture/replayFrame.ts
  var script = document.currentScript ?? document.querySelector("script[data-ih-sx]");
  var sx = Number(script == null ? void 0 : script.getAttribute("data-ih-sx")) || 0;
  var sy = Number(script == null ? void 0 : script.getAttribute("data-ih-sy")) || 0;
  var de = document.documentElement;
  var opened = false;
  var last = null;
  var asked = null;
  var started = 0;
  var gaveUp = false;
  var waited = 0;
  var frames = 0;
  var base = {};
  var fb = {};
  var pending = [];
  var cAnchor = null;
  var cKey = "";
  var cEl = null;
  var cTries = 0;
  var pos = (el) => anchorPx(document, el);
  var r2 = (v) => Math.round(v * 100) / 100;
  function shifts() {
    const out = {};
    const els = document.querySelectorAll(\`[\${ANCHOR_ATTR}]\`);
    for (let i = 0; i < els.length; i++) {
      const p = pos(els[i]);
      if (!p) continue;
      for (const t of parseAnchors(els[i].getAttribute(ANCHOR_ATTR))) {
        const b = t.at ?? (base[t.key] = base[t.key] || p);
        out[t.key] = [r2(p[0] - b[0]), r2(p[1] - b[1])];
      }
    }
    for (const k in fb) {
      const p = pos(fb[k].el);
      if (p) out[k] = [r2(p[0] - fb[k].x), r2(p[1] - fb[k].y)];
    }
    return out;
  }
  function jump(el, left, top) {
    try {
      el.scrollTo({ top, left, behavior: "instant" });
    } catch {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  }
  var inner = [];
  var frozen = document.querySelectorAll("[data-ih-scroll]");
  for (let i = 0; i < frozen.length; i++) {
    const el = frozen[i];
    const p = (el.getAttribute("data-ih-scroll") || "").split(",");
    inner.push([el, +p[0] || 0, +p[1] || 0]);
    const kids = el.children;
    for (let j = kids.length - 1; j >= 0; j--) if (kids[j].hasAttribute("data-ih-spacer")) el.removeChild(kids[j]);
    el.removeAttribute("data-ih-scroll");
  }
  var scroller = null;
  var moved = null;
  var picks = 0;
  var initPg = [0, 0];
  function atSaved(fn) {
    const els = [de, document.body, moved].filter((el, i, a) => !!el && a.indexOf(el) === i);
    const was = els.map((el) => [el.scrollLeft, el.scrollTop]);
    scrollWindowTo(document, sx, sy);
    if (moved && moved !== de && moved !== document.body) jump(moved, initPg[0], initPg[1]);
    try {
      fn();
    } finally {
      for (let i = 0; i < els.length; i++) jump(els[i], was[i][0], was[i][1]);
    }
  }
  function place() {
    atSaved(() => {
      pending = pending.filter(([id, x, y, w, h]) => {
        const el = anchorFor(document, { left: x, top: y, right: x + w, bottom: y + h });
        const p = el && pos(el);
        if (!el || !p) return true;
        fb[id] = { el, x: p[0], y: p[1] };
        return false;
      });
    });
  }
  function placeCallout() {
    if (!cAnchor || cEl || cTries++ > 300) return;
    cEl = calloutElement(document, scroller, cAnchor);
  }
  function sendState() {
    if (!opened) return;
    if (pending.length && waited++ < 300) place();
    placeCallout();
    const [curSx, curSy] = windowScroll(document);
    if (picks < 4 && ++frames % 60 === 0) {
      scroller = pickScroller(document);
      picks++;
    }
    const pg = scrollPos(document, scroller);
    const out = shifts();
    const t = cAnchor && cEl ? calloutTip(document, cEl, cAnchor) : null;
    const ctip = t && [r2(t[0]), r2(t[1])];
    const msgKey = JSON.stringify(out) + ":" + curSx + ":" + curSy + ":" + pg[0] + ":" + pg[1] + ":" + ctip;
    if (msgKey !== last) {
      last = msgKey;
      parent.postMessage({
        ihReplay: 1,
        ready: true,
        opened,
        asked,
        shifts: out,
        scrollX: curSx,
        scrollY: curSy,
        initSx: sx,
        initSy: sy,
        pageX: pg[0],
        pageY: pg[1],
        initPageX: initPg[0],
        initPageY: initPg[1],
        ctip
      }, "*");
    }
  }
  function tick() {
    requestAnimationFrame(tick);
    sendState();
  }
  function anchorBoxes(boxes) {
    const have = {};
    const els = document.querySelectorAll(\`[\${ANCHOR_ATTR}]\`);
    for (let i = 0; i < els.length; i++) for (const t of parseAnchors(els[i].getAttribute(ANCHOR_ATTR))) have[t.key] = 1;
    for (let i = 0; i < boxes.length && i < 100; i++) {
      const b = boxes[i];
      if (!Array.isArray(b) || b.length !== 5 || typeof b[0] !== "string" || !/^[A-Za-z0-9_-]+$/.test(b[0]) || have[b[0]] || fb[b[0]]) continue;
      if (typeof b[1] !== "number" || typeof b[2] !== "number" || typeof b[3] !== "number" || typeof b[4] !== "number") continue;
      if (!isFinite(b[1] + b[2] + b[3] + b[4])) continue;
      pending.push(b);
    }
    if (opened) sendState();
  }
  function anchorCallout(c) {
    const ok = Array.isArray(c) && c.length === 6 && c.every((v) => typeof v === "number" && isFinite(v));
    const key = ok ? c.join(",") : "";
    if (key === cKey) return;
    cKey = key;
    cAnchor = ok ? { px: c[0], py: c[1], sx: c[2], sy: c[3], ox: c[4], oy: c[5] } : null;
    cEl = null;
    cTries = 0;
  }
  function scrollInner() {
    let ok = true;
    for (const [el, top, left] of inner) {
      if (!el.clientHeight && !el.clientWidth) ok = false;
      else jump(el, left, top);
    }
    return ok;
  }
  var GIVE_UP_MS = 1200;
  function tryOpen() {
    if (opened) return;
    if (!started) started = performance.now();
    const laidOut = scrollInner();
    scrollWindowTo(document, sx, sy);
    const [x, y] = windowScroll(document);
    if (!(laidOut && Math.abs(x - sx) < 1 && Math.abs(y - sy) < 1) && !gaveUp && performance.now() - started < GIVE_UP_MS) {
      for (const [el] of inner) jump(el, 0, 0);
      jump(de, 0, 0);
      if (document.body) jump(document.body, 0, 0);
      parent.postMessage({ ihReplay: "wait" }, "*");
      return;
    }
    scroller = moved = pickScroller(document);
    picks = 1;
    initPg = scrollPos(document, scroller);
    shifts();
    if (pending.length) place();
    scrollToTop(document, scroller);
    opened = true;
    sendState();
  }
  function takeOver() {
    gaveUp = true;
  }
  var isScrollLocked = false;
  var SCROLL_KEYS = ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " ", 38, 40, 33, 34, 36, 35, 32];
  function handleInput(ev) {
    if (isScrollLocked) {
      if (ev.type === "wheel" || ev.type === "touchmove") {
        ev.preventDefault();
        return;
      }
      if (ev.type === "keydown") {
        const k = ev.key || ev.keyCode;
        if (SCROLL_KEYS.indexOf(k) >= 0) {
          ev.preventDefault();
          return;
        }
      }
    }
    takeOver();
  }
  for (const type of ["wheel", "touchmove", "touchstart", "mousedown", "keydown"]) addEventListener(type, handleInput, { capture: true, passive: false });
  if (document.readyState === "complete") tryOpen();
  else addEventListener("load", tryOpen);
  requestAnimationFrame(tick);
  addEventListener("message", (e) => {
    const d = e.data;
    if (e.source !== parent || !d) return;
    if (d.ihReplay === "ping") {
      tryOpen();
      return;
    }
    if (d.ihReplay === "anchor" && d.boxes && typeof d.boxes.length === "number") {
      anchorCallout(d.callout);
      anchorBoxes(d.boxes);
      return;
    }
    if (d.ihReplay === "lockScroll") {
      isScrollLocked = !!d.locked;
      let lockEl = document.getElementById("data-ih-lock-scroll");
      if (isScrollLocked) {
        if (!lockEl) {
          lockEl = document.createElement("style");
          lockEl.id = "data-ih-lock-scroll";
          lockEl.textContent = "html, body { overflow: hidden !important; overscroll-behavior: none !important; touch-action: none !important; }";
          (document.head || de).appendChild(lockEl);
        }
      } else if (lockEl && lockEl.parentNode) {
        lockEl.parentNode.removeChild(lockEl);
      }
      return;
    }
    if (d.ihReplay === "top") {
      if (typeof d.n === "number") asked = d.n;
      last = null;
      sendState();
      return;
    }
    if (d.ihReplay === "scrollTo") {
      takeOver();
      const targetX = typeof d.x === "number" ? d.x : sx;
      const targetY = typeof d.y === "number" ? d.y : sy;
      if (!scroller) scroller = pickScroller(document);
      if (scroller && scroller !== (document.scrollingElement || de) && scroller !== document.body) {
        try {
          scroller.scrollTo({ left: targetX, top: targetY, behavior: d.behavior || "smooth" });
        } catch {
          scroller.scrollLeft = targetX;
          scroller.scrollTop = targetY;
        }
      } else {
        if (typeof window.scrollTo === "function") {
          try {
            window.scrollTo({ left: targetX, top: targetY, behavior: d.behavior || "smooth" });
          } catch {
            window.scrollTo(targetX, targetY);
          }
        }
        if (de.scrollTop !== targetY && document.body) {
          document.body.scrollLeft = targetX;
          document.body.scrollTop = targetY;
        }
      }
      return;
    }
    if (d.ihReplay !== "wheel" || isScrollLocked) return;
    takeOver();
    const list = [];
    for (let el = document.elementFromPoint(d.x, d.y); el && el !== de && el !== document.body; el = el.parentElement) {
      const cs = getComputedStyle(el);
      if (/auto|scroll|overlay/.test(cs.overflowY + " " + cs.overflowX)) list.push(el);
    }
    if (scroller && list.indexOf(scroller) < 0) list.push(scroller);
    if (document.body) list.push(document.body);
    list.push(de);
    for (const t of list) {
      const top = t.scrollTop;
      const left = t.scrollLeft;
      t.scrollBy(d.dx, d.dy);
      if (t.scrollTop !== top || t.scrollLeft !== left) break;
    }
  });
})();`;
